export default "__VITE_ASSET__vRW4P0$X__"